(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[310],{

/***/ 9715:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const punycode = __webpack_require__(3689)
const sldMap = __webpack_require__(7086)
const ccTldMap = __webpack_require__(2678)

module.exports = function isValidDomain (value, opts) {
  if (typeof value !== 'string') return false
  if (!(opts instanceof Object)) opts = {}
  value = value.toLowerCase()

  if (value.endsWith('.')) {
    value = value.slice(0, value.length - 1)
  }

  if (opts.allowUnicode) {
    value = punycode.toASCII(value)
  }

  if (value.length > 253) {
    return false
  }

  const validChars = /^([\u0E00-\u0E7Fa-z0-9-._*]+)$/g
  if (!validChars.test(value)) {
    return false
  }

  if (opts.topLevel) {
    if (ccTldMap[value.replace(/\.$/, '')]) {
      return true
    }
  }

  const sldRegex = /(.*)\.(([\u0E00-\u0E7Fa-z0-9]+)(\.[a-z0-9]+))/
  const matches = value.match(sldRegex)
  var tld = null
  var labels = null
  if (matches && matches.length > 2) {
    if (sldMap[matches[2]]) {
      tld = matches[2]
      labels = matches[1].split('.')
    }
  }

  if (!labels) {
    labels = value.split('.')
    if (labels.length <= 1) return false

    tld = labels.pop()
    const tldRegex = /^(?:xn--)?(?!^\d+$)[\u0E00-\u0E7Fa-z0-9]+$/gi

    if (!tldRegex.test(tld)) return false
  }

  if (opts.subdomain === false && labels.length > 1) return false

  const isValid = labels.every(function (label, index) {
    if (opts.wildcard && index === 0 && label === '*' && labels.length > 1) {
      return true
    }

    let validLabelChars = /^([\u0E00-\u0E7Fa-zA-Z0-9-_]+)$/g
    if (index === labels.length - 1) {
      validLabelChars = /^([\u0E00-\u0E7Fa-zA-Z0-9-]+)$/g
    }

    // https://github.com/miguelmota/is-valid-domain/issues/22
    const doubleDashCount = (label.match(/--(--)?/g) || []).length
    const xnDashCount = (label.match(/xn--/g) || []).length
    if (doubleDashCount !== xnDashCount) {
      return false
    }

    const isValid = (
      validLabelChars.test(label) &&
      label.length < 64 &&
      !label.startsWith('-') &&
      !label.endsWith('-')
    )

    return isValid
  })

  return isValid
}


/***/ }),

/***/ 247:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play-to-earn/games",
      function () {
        return __webpack_require__(2394);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ PlayToEarnGames; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./styles/layout.module.css
var layout_module = __webpack_require__(7272);
var layout_module_default = /*#__PURE__*/__webpack_require__.n(layout_module);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 37 modules
var esm = __webpack_require__(3562);
// EXTERNAL MODULE: ./src/util/src/i18next.ts
var i18next = __webpack_require__(4873);
// EXTERNAL MODULE: ./styles/guides.module.css
var guides_module = __webpack_require__(1775);
var guides_module_default = /*#__PURE__*/__webpack_require__.n(guides_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(6792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Col.js




const DEVICE_SIZES = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const Col = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'col');
  const spans = [];
  const classes = [];
  DEVICE_SIZES.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;

    if (typeof propValue === 'object' && propValue != null) {
      ({
        span = true,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }

    const infix = brkPoint !== 'xs' ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${prefix}${infix}` : `${prefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });

  if (!spans.length) {
    spans.push(prefix); // plain 'col'
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...props,
    ref: ref,
    className: classnames_default()(className, ...spans, ...classes)
  });
});
Col.displayName = 'Col';
/* harmony default export */ var esm_Col = (Col);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./src/util/src/zod.ts + 1 modules
var zod = __webpack_require__(6338);
;// CONCATENATED MODULE: ./src/Generic/models/Name.ts

var NameSchema = lib.z.string().min(1);

// EXTERNAL MODULE: ./src/Generic/models/Url.ts
var Url = __webpack_require__(7117);
// EXTERNAL MODULE: ./src/Generic/models/Id.ts
var Id = __webpack_require__(7469);
;// CONCATENATED MODULE: ./src/Social/models/WithSubscriberCountEstimate.ts

var WithSubscriberCountEstimateSchema = lib.z.object({
    subscriberCount: lib.z.number().int().nonnegative(),
    subscriberCountEstimatedAt: lib.z.date()
});

// EXTERNAL MODULE: ./src/util/src/uid.ts
var uid = __webpack_require__(2927);
// EXTERNAL MODULE: ./src/util/src/string.ts
var string = __webpack_require__(146);
;// CONCATENATED MODULE: ./src/Generic/models/Notes.ts


var NotesSchema = lib.z.string().optional().transform(transformNotes);
function validateNotes(notes) {
    return NotesSchema.parse(notes);
}
function transformNotes(notes) {
    return notes ? (0,string/* nail */.jQ)(notes) : notes;
}

// EXTERNAL MODULE: ./node_modules/is-valid-domain/index.js
var is_valid_domain = __webpack_require__(9715);
var is_valid_domain_default = /*#__PURE__*/__webpack_require__.n(is_valid_domain);
;// CONCATENATED MODULE: ./src/DNS/models/Domain.ts


var DomainSchema = lib.z.string().min(1).refine((is_valid_domain_default()));
function validateDomain(domain) {
    return DomainSchema.parse(domain);
}
function getDomainUid(domain) {
    return domain;
}

;// CONCATENATED MODULE: ./src/Social/models/SocialNetwork.ts




var SocialNetworkSchema = lib.z.object({
    name: lib.z.string().min(1),
    domain: DomainSchema
});
var SocialNetworksSchema = lib.z.array(SocialNetworkSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("SocialNetwork", getSocialNetworkUid));
var SocialNetworkUidSchema = SocialNetworkSchema.pick({
    domain: true
});
function validateSocialNetwork(network) {
    return SocialNetworkSchema.parse(network);
}
function validateSocialNetworks(networks) {
    return SocialNetworksSchema.parse(networks);
}
function getSocialNetworkUid(networkUid) {
    return (0,uid/* toUidFromSchema */.RY)(networkUid, SocialNetworkUidSchema);
}

// EXTERNAL MODULE: ./src/Generic/models/UrlPattern.ts
var UrlPattern = __webpack_require__(9786);
;// CONCATENATED MODULE: ./src/Social/models/SocialChannelType.ts







var SocialChannelTypeSchema = lib.z.object({
    name: NameSchema,
    network: SocialNetworkSchema,
    followUrlPattern: UrlPattern/* UrlPatternSchema */.Ie,
    notes: NotesSchema
});
var SocialChannelTypesSchema = lib.z.array(SocialChannelTypeSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("SocialChannelType", getSocialChannelTypeUid));
var SocialChannelTypeUidSchema = lib.z.object({
    name: SocialChannelTypeSchema.shape.name,
    network: SocialNetworkUidSchema
});
function validateSocialChannelType(type) {
    return SocialChannelTypeSchema.parse(type);
}
function validateSocialChannelTypes(types) {
    return SocialChannelTypesSchema.parse(types);
}
function getSocialChannelTypeUid(typeUid) {
    return (0,uid/* toUidFromSchema */.RY)(typeUid, SocialChannelTypeUidSchema);
}

// EXTERNAL MODULE: ./src/util/src/ensure.ts
var src_ensure = __webpack_require__(6600);
;// CONCATENATED MODULE: ./src/Generic/models/OriginalId.ts


var OriginalIdSchema = lib.z.string().min(1);
function validateExternalId(externalId) {
    return OriginalIdSchema.parse(externalId);
}
function byOriginalId(originalId) {
    return function(object) {
        return object.originalId === originalId;
    };
}
function getByOriginalId(objects, originalId) {
    return ensure(objects.find(byOriginalId(originalId)), err("Cannot get object by id: ".concat(originalId)));
}

;// CONCATENATED MODULE: ./src/Generic/models/OriginalSlug.ts


var OriginalSlugSchema = lib.z.string().min(1);
function validateExternalSlug(externalSlug) {
    return OriginalSlugSchema.parse(externalSlug);
}
function byOriginalSlug(originalSlug) {
    return function(object) {
        return object.originalSlug === originalSlug;
    };
}
function getByOriginalSlug(objects, originalSlug) {
    return ensure(objects.find(byOriginalSlug(originalSlug)), err("Cannot get object by slug: ".concat(originalSlug)));
}

;// CONCATENATED MODULE: ./src/Social/models/SocialChannel.ts







var SocialChannelSchema = lib.z.object({
    oid: OriginalIdSchema.optional(),
    slug: OriginalSlugSchema,
    type: SocialChannelTypeSchema,
    notes: NotesSchema
});
var SocialChannelsSchema = lib.z.array(SocialChannelSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("SocialChannel", getSocialChannelUid));
var SocialChannelUidSchema = lib.z.object({
    slug: SocialChannelSchema.shape.slug,
    type: SocialChannelTypeUidSchema
});
function validateSocialChannel(channel) {
    return SocialChannelSchema.parse(channel);
}
function validateSocialChannels(channels) {
    return SocialChannelsSchema.parse(channels);
}
function getSocialChannelUid(channelUid) {
    return (0,uid/* toUidFromSchema */.RY)(channelUid, SocialChannelUidSchema);
}

;// CONCATENATED MODULE: ./src/PlayToEarn/models/GameSocialChannel.ts




var GameSocialChannelSchema = SocialChannelSchema.extend(WithSubscriberCountEstimateSchema.shape);
var GameSocialChannelsSchema = lib.z.array(GameSocialChannelSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("GameSocialChannel", parseGameSocialChannelUid));
var GameSocialChannelUidSchema = SocialChannelUidSchema;
function parseGameSocialChannel(channel) {
    return GameSocialChannelSchema.parse(channel);
}
function parseGameSocialChannels(channels) {
    return GameSocialChannelsSchema.parse(channels);
}
function parseGameSocialChannelUid(channelUid) {
    return GameSocialChannelUidSchema.parse(channelUid);
}

;// CONCATENATED MODULE: ./src/Generic/models/DateInterval.ts


var DateIntervalSchema = lib.z.object({
    from: lib.z.date(),
    to: lib.z.date()
});
var DateIntervalsSchema = lib.z.array(DateIntervalSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("DateInterval", parseDateIntervalUid));
var DateIntervalUidSchema = DateIntervalSchema;
function parseDateInterval(interval) {
    return DateIntervalSchema.parse(interval);
}
function parseDateIntervals(intervals) {
    return DateIntervalsSchema.parse(intervals);
}
function parseDateIntervalUid(intervalUid) {
    return DateIntervalUidSchema.parse(intervalUid);
}

;// CONCATENATED MODULE: ./src/PlayToEarn/models/Product.ts




var ProductSchema = lib.z.object({
    id: Id/* IdSchema */.KI,
    releaseExpectedAtInterval: DateIntervalSchema
});
var ProductsSchema = lib.z.array(ProductSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("Product", parseProductUid));
var ProductUidSchema = ProductSchema.pick({
    id: true
});
function parseProduct(product) {
    return ProductSchema.parse(product);
}
function parseProducts(products) {
    return ProductsSchema.parse(products);
}
function parseProductUid(productUid) {
    return ProductUidSchema.parse(productUid);
}

;// CONCATENATED MODULE: ./src/Generic/models/ImageUrl.ts

var ImageUrlSchema = Url/* UrlSchema */.z;

;// CONCATENATED MODULE: ./src/Finance/models/Ticker.ts


var TickerRegex = /^[a-zA-Z0-9]+$/;
var TickerSchema = lib.z.string().min(1).regex(TickerRegex, "Must match a CoinMarketCap ticker (examples: BTC, ETH, 1INCH)");
function getByTicker(objects, ticker) {
    return ensure(objects.find(function(o) {
        return o.ticker === ticker;
    }));
}

;// CONCATENATED MODULE: ./src/Finance/models/Tasset.ts







/**
 * Tasset is a tangible asset
 *
 * Example groups:
 * - Coins
 * - Tokens
 * - Shares
 * - Currencies
 *
 * Non-example groups:
 * - NFTs (because they are non-fungible)
 * - Houses (because they are immobile)
 * - Song rights (because they are intangible)
 */ var TassetSchema = lib.z.object({
    id: Id/* IdSchema */.KI,
    name: NameSchema,
    ticker: TickerSchema,
    notes: NotesSchema
}).describe("Tasset");
var TassetsSchema = lib.z.array(TassetSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("Tasset", parseTassetUid));
var TassetUidSchema = TassetSchema.pick({
    id: true
});
function parseTasset(tasset) {
    return TassetSchema.parse(tasset);
}
function parseTassets(tassets) {
    return TassetsSchema.parse(tassets);
}
function parseTassetUid(tassetUid) {
    return TassetUidSchema.parse(tassetUid);
}
var byTasset = function(tasset) {
    return function(object) {
        return isEqual(object.asset, tasset);
    };
};

;// CONCATENATED MODULE: ./src/PlayToEarn/models/Token.ts





var TokenSchema = lib.z.object({
    id: Id/* IdSchema */.KI,
    asset: TassetSchema,
    tokenomics: lib.z.array(ImageUrlSchema),
    tokenomicsAvailableAt: lib.z.date().nullable()
});
var TokensSchema = lib.z.array(TokenSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("Token", parseTokenUid));
var TokenUidSchema = TokenSchema.pick({
    id: true
});
function parseToken(token) {
    return TokenSchema.parse(token);
}
function parseTokens(tokens) {
    return TokensSchema.parse(tokens);
}
function parseTokenUid(tokenUid) {
    return TokenUidSchema.parse(tokenUid);
}

;// CONCATENATED MODULE: ./src/PlayToEarn/models/InvestorType.ts

var InvestorTypeSchema = lib.z["enum"]([
    "Fund",
    "Influencer",
    "MarketingAgency"
]);

;// CONCATENATED MODULE: ./src/PlayToEarn/models/Investor.ts





var InvestorSchema = lib.z.object({
    type: InvestorTypeSchema,
    name: NameSchema,
    url: Url/* UrlSchema */.z
});
var InvestorsSchema = lib.z.array(InvestorSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("Investor", parseInvestorUid));
var InvestorUidSchema = InvestorSchema.pick({
    url: true
});
function parseInvestor(investor) {
    return InvestorSchema.parse(investor);
}
function parseInvestors(investors) {
    return InvestorsSchema.parse(investors);
}
function parseInvestorUid(investorUid) {
    return InvestorUidSchema.parse(investorUid);
}

;// CONCATENATED MODULE: ./src/PlayToEarn/models/Game.ts









var GameSchema = lib.z.object({
    id: Id/* IdSchema */.KI,
    name: NameSchema,
    description: lib.z.string().optional(),
    image: Url/* UrlSchema */.z,
    website: Url/* UrlSchema */.z,
    roadmap: Url/* UrlSchema.optional */.z.optional(),
    roadmapAvailableAt: lib.z.date().nullable(),
    docs: lib.z.array(Url/* UrlSchema */.z),
    calculators: lib.z.array(Url/* UrlSchema */.z),
    channels: lib.z.array(GameSocialChannelSchema),
    investors: lib.z.array(InvestorSchema),
    investorsCount: lib.z.number(),
    products: lib.z.array(ProductSchema),
    tokens: lib.z.array(TokenSchema)
});
var GamesSchema = lib.z.array(GameSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("Game", parseGameUid));
var GameUidSchema = GameSchema.pick({
    id: true
});
function parseGame(game) {
    return GameSchema.parse(game);
}
function parseGames(games) {
    return GamesSchema.parse(games);
}
function parseGameUid(gameUid) {
    return GameUidSchema.parse(gameUid);
}

;// CONCATENATED MODULE: ./src/util/src/todo.ts
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent1, args1, Class1) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class2) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class2);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// allows to implement partial functions & leave a message for another developer

function todo(value, message) {
    return value;
}
function stub(message) {
    throw impl(message);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function impl() {
    var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return new ImplementationError(nail(message).trim());
}
var Impl = function Impl() {
    throw impl();
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function manual(map, key, message) {
    var value = map[key];
    if (!value) throw impl(message);
    return value;
}
var ImplementationError = /*#__PURE__*/ function(Error) {
    "use strict";
    _inherits(ImplementationError, Error);
    var _super = _createSuper(ImplementationError);
    function ImplementationError() {
        _classCallCheck(this, ImplementationError);
        return _super.apply(this, arguments);
    }
    return ImplementationError;
}(_wrapNativeSuper(Error));
var manually = (/* unused pure expression or super */ null && (impl));

;// CONCATENATED MODULE: ./src/Social/data/allDomains.ts

var FacebookCom = validateDomain("facebook.com");
var TwitterCom = validateDomain("twitter.com");
var TelegramOrg = validateDomain("telegram.org");
var DiscordCom = validateDomain("discord.com");
var InstagramCom = validateDomain("instagram.com");
var PinterestCom = validateDomain("pinterest.com");
var YouTubeCom = validateDomain("youtube.com");
var MediumCom = validateDomain("medium.com");
var GitHubCom = validateDomain("github.com");
var LinkedInCom = validateDomain("linkedin.com");
var AnchorFm = validateDomain("anchor.fm");
var RedditCom = validateDomain("reddit.com");

;// CONCATENATED MODULE: ./src/Social/data/allSocialNetworks.ts



var allSocialNetworks = [];
var addSocialNetwork = (0,zod/* getInserter */.VE)("SocialNetwork", SocialNetworkSchema, getSocialNetworkUid, allSocialNetworks);
var findSocialNetwork = (0,zod/* getFinder */.QC)(getSocialNetworkUid, allSocialNetworks);
var Facebook = addSocialNetwork({
    name: "Facebook",
    domain: FacebookCom
});
var Twitter = addSocialNetwork({
    name: "Twitter",
    domain: TwitterCom
});
var Telegram = addSocialNetwork({
    name: "Telegram",
    domain: TelegramOrg
});
var Discord = addSocialNetwork({
    name: "Discord",
    domain: DiscordCom
});
var Instagram = addSocialNetwork({
    name: "Instagram",
    domain: InstagramCom
});
var Pinterest = addSocialNetwork({
    name: "Pinterest",
    domain: PinterestCom
});
var YouTube = addSocialNetwork({
    name: "YouTube",
    domain: YouTubeCom
});
var Reddit = addSocialNetwork({
    name: "Reddit",
    domain: RedditCom
});
var Medium = addSocialNetwork({
    name: "Medium",
    domain: MediumCom
});
var GitHub = addSocialNetwork({
    name: "GitHub",
    domain: GitHubCom
});
var LinkedIn = addSocialNetwork({
    name: "LinkedIn",
    domain: LinkedInCom
});
var Anchor = addSocialNetwork({
    name: "Anchor",
    domain: AnchorFm
});

;// CONCATENATED MODULE: ./src/Social/data/allSocialChannelTypes.ts



var allSocialChannelTypes = [];
var addSocialChannelType = (0,zod/* getInserter */.VE)("SocialChannelType", SocialChannelTypeSchema, getSocialChannelTypeUid, allSocialChannelTypes);
var findSocialChannelType = (0,zod/* getFinder */.QC)(getSocialChannelTypeUid, allSocialChannelTypes);
var TelegramGroup = addSocialChannelType({
    name: "Group",
    network: Telegram,
    // TODO: Some groups use "https://t.me/joinchat/{{slug}}" pattern
    followUrlPattern: "https://t.me/{{slug}}"
});
var TelegramChannel = addSocialChannelType({
    name: "Channel",
    network: Telegram,
    followUrlPattern: "https://t.me/{{slug}}"
});
var TwitterProfile = addSocialChannelType({
    name: "Profile",
    network: Twitter,
    followUrlPattern: "https://twitter.com/{{slug}}"
});
var YouTubeChannel = addSocialChannelType({
    name: "Channel",
    network: YouTube,
    followUrlPattern: "https://www.youtube.com/channel/{{slug}}"
});
var DiscordServer = addSocialChannelType({
    name: "Server",
    network: Discord,
    followUrlPattern: "https://discord.gg/{{slug}}"
});
var RedditSubreddit = addSocialChannelType({
    name: "Subreddit",
    network: Reddit,
    followUrlPattern: "https://www.reddit.com/r/{{slug}}"
});
var MediumProfile = addSocialChannelType({
    name: "Profile",
    network: Medium,
    followUrlPattern: "https://{{slug}}.medium.com/"
});
var MediumPublication = addSocialChannelType({
    name: "Publication",
    network: Medium,
    followUrlPattern: "https://medium.com/{{slug}}"
});
var GitHubProfile = addSocialChannelType({
    name: "Profile",
    network: GitHub,
    followUrlPattern: "https://github.com/{{slug}}"
});
var GitHubOrganization = addSocialChannelType({
    name: "Organization",
    network: GitHub,
    followUrlPattern: "https://github.com/{{slug}}"
});
var AnchorPodcast = addSocialChannelType({
    name: "Podcast",
    network: Anchor,
    followUrlPattern: "https://anchor.fm/{{slug}}"
});
var LinkedInCompany = addSocialChannelType({
    name: "Company",
    network: LinkedIn,
    followUrlPattern: "https://www.linkedin.com/company/{{slug}}"
});
var InstagramProfile = addSocialChannelType({
    name: "Profile",
    network: Instagram,
    followUrlPattern: "https://www.instagram.com/{{slug}}/"
});
var FacebookPage = addSocialChannelType({
    name: "Page",
    network: Facebook,
    followUrlPattern: "https://facebook.com/{{slug}}"
});

;// CONCATENATED MODULE: ./src/PlayToEarn/data/allInvestors.ts


var allInvestors = [];
var addInvestor = (0,zod/* getInserter */.VE)("Investor", InvestorSchema, parseInvestorUid, allInvestors);
var findInvestor = (0,zod/* getFinder */.QC)(parseInvestorUid, allInvestors);
var PanteraCapital = addInvestor({
    name: "Pantera Capital",
    url: "https://panteracapital.com/",
    type: "Fund"
});

;// CONCATENATED MODULE: ./src/util/src/duration.ts
function duration(length, unit) {
    switch(unit){
        case "d":
        case "day":
        case "days":
            return length * 60 * 60 * 24;
        case "h":
        case "hr":
        case "hrs":
        case "hour":
        case "hours":
            return length * 60 * 60;
        case "m":
        case "min":
        case "mins":
        case "minute":
        case "minutes":
            return length * 60;
        case "s":
        case "sec":
        case "second":
        case "seconds":
            return length;
        default:
            throw new Error("Unknown unit: ".concat(unit));
    }
}
var milliseconds = 1;
var seconds = 1000 * milliseconds;
var minutes = 60 * seconds;
var hours = 60 * minutes;
var days = 24 * hours;
var weeks = 7 * days;
var months = 30 * days // nominal, not calendar
;
var years = 12 * months;
// naming sugar
var millisecond = (/* unused pure expression or super */ null && (milliseconds));
var second = (/* unused pure expression or super */ null && (seconds));
var minute = (/* unused pure expression or super */ null && (minutes));
var hour = (/* unused pure expression or super */ null && (hours));
var duration_day = (/* unused pure expression or super */ null && (days));
var week = (/* unused pure expression or super */ null && (weeks));
var month = (/* unused pure expression or super */ null && (months));
var year = (/* unused pure expression or super */ null && (years));

;// CONCATENATED MODULE: ./src/util/src/date.ts


var MAX_DATE = new Date(8640000000000000);
var MIN_DATE = new Date(-8640000000000000);
var already = new Date(0);
function equal(a, b) {
    return a.getTime() === b.getTime();
}
function yesterday(now) {
    return new Date(now.getTime() - day);
}
function add(date, durationInMilliseconds) {
    return new Date(date.getTime() + durationInMilliseconds);
}
function sub(date, durationInMilliseconds) {
    return new Date(date.getTime() - durationInMilliseconds);
}
function timeBetween(fromHour, toHour, date) {
    var hour = DateTime.fromJSDate(date, {
        zone: "UTC"
    }).hour;
    return hour >= fromHour && hour < toHour;
}
function truncateToDay(date) {
    return DateTime.fromJSDate(date, {
        zone: "UTC"
    }).startOf("day").toJSDate();
} // export function addBusiness(date: Date, duration: Duration) {
 //   return DateTimeBusiness.fromJSDate(date).plusBusiness(duration).toJSDate()
 // }

;// CONCATENATED MODULE: ./src/Generic/models/Name/withIdFromName.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function withIdFromName($object) {
    return _objectSpread({}, $object, {
        id: (0,Id/* fromStringToId */.hH)($object.name)
    });
}

;// CONCATENATED MODULE: ./src/PlayToEarn/data/allTassets.ts



var allTassets = [];
var addTasset = (0,zod/* getInserter */.VE)((0,zod/* getName */.oY)(TassetSchema), TassetSchema, parseTassetUid, allTassets);
var findTasset = (0,zod/* getFinder */.QC)(parseTassetUid, allTassets);
var GHST = addTasset(withIdFromName({
    name: "Aavegotchi",
    ticker: "GHST"
}));

;// CONCATENATED MODULE: ./src/Stepn/data/allTassets.ts



var allTassets_allTassets = [];
var allTassets_addTasset = (0,zod/* getInserter */.VE)((0,zod/* getName */.oY)(TassetSchema), TassetSchema, parseTassetUid, allTassets_allTassets);
var allTassets_findTasset = (0,zod/* getFinder */.QC)(parseTassetUid, allTassets_allTassets);
var GST = allTassets_addTasset(withIdFromName({
    name: "Green Satoshi Token",
    ticker: "GST",
    notes: "\n    Utility:\n    * Upgrade\n  "
}));
var GMT = allTassets_addTasset(withIdFromName({
    name: "Green Metaverse Token",
    ticker: "GMT",
    notes: "\n    Utility:\n    * Governance\n  "
}));

;// CONCATENATED MODULE: ./src/Genopets/data/allTassets.ts


var data_allTassets_allTassets = [];
var data_allTassets_addTasset = (0,zod/* getInserter */.VE)((0,zod/* getName */.oY)(TassetSchema), TassetSchema, parseTassetUid, data_allTassets_allTassets);
var data_allTassets_findTasset = (0,zod/* getFinder */.QC)(parseTassetUid, data_allTassets_allTassets);
var GENE = data_allTassets_addTasset({
    id: "GENE",
    name: "Genopets",
    ticker: "GENE"
});
var KI = data_allTassets_addTasset({
    id: "KI",
    name: "KI",
    ticker: "KI"
});

;// CONCATENATED MODULE: ./src/Letmespeak/data/allTassets.ts


var Letmespeak_data_allTassets_allTassets = [];
var Letmespeak_data_allTassets_addTasset = (0,zod/* getInserter */.VE)((0,zod/* getName */.oY)(TassetSchema), TassetSchema, parseTassetUid, Letmespeak_data_allTassets_allTassets);
var Letmespeak_data_allTassets_findTasset = (0,zod/* getFinder */.QC)(parseTassetUid, Letmespeak_data_allTassets_allTassets);
var LSTAR = Letmespeak_data_allTassets_addTasset({
    id: "LSTAR",
    name: "Letmespeak",
    ticker: "LSTAR"
});

;// CONCATENATED MODULE: ./src/PlayToEarn/data/allTokens.ts








var allTokens = [];
var addToken = (0,zod/* getInserter */.VE)("Token", TokenSchema, parseTokenUid, allTokens);
var findToken = (0,zod/* getFinder */.QC)(parseTokenUid, allTokens);
var Aavegotchi_GHST = addToken({
    id: "Aavegotchi_GHST",
    asset: GHST,
    tokenomics: [
        "https://wiki.aavegotchi.com/en/tokenomics"
    ],
    tokenomicsAvailableAt: already
});
var Stepn_GST = addToken({
    id: "Stepn_GST",
    asset: GST,
    tokenomics: todo([]),
    tokenomicsAvailableAt: already
});
var Stepn_GMT = addToken({
    id: "Stepn_GMT",
    asset: GMT,
    tokenomics: todo([]),
    tokenomicsAvailableAt: already
});
var Genopets_GENE = addToken({
    id: "Genopets_GENE",
    asset: GENE,
    tokenomics: [
        // source: https://docsend.com/view/b9bqd2j78nekzdgr
        "https://i.imgur.com/ILSDwaz.png",
        "https://i.imgur.com/FjIxi2p.png", 
    ],
    tokenomicsAvailableAt: already
});
var Genopets_KI = addToken({
    id: "Genopets_KI",
    asset: KI,
    tokenomics: [],
    tokenomicsAvailableAt: null
});
var Letmespeak_LSTAR = addToken({
    id: "Letmespeak_LSTAR",
    asset: LSTAR,
    tokenomics: [],
    tokenomicsAvailableAt: null
});

;// CONCATENATED MODULE: ./src/PlayToEarn/data/allGames.ts







var allGames = [];
var addGame = (0,zod/* getInserter */.VE)("Game", GameSchema, parseGameUid, allGames);
var findGame = (0,zod/* getFinder */.QC)(parseGameUid, allGames);
var Genopets = addGame({
    id: "Genopets",
    name: "Genopets",
    description: "Genopets is a game that makes it rewarding to live an active lifestyle.",
    image: "https://i.imgur.com/qSA6vvh.jpg",
    website: "https://www.genopets.me/",
    docs: [
        "https://docsend.com/view/b9bqd2j78nekzdgr"
    ],
    calculators: [],
    channels: [
        {
            type: DiscordServer,
            slug: "genopets",
            subscriberCount: 137423,
            subscriberCountEstimatedAt: new Date("2022-04-13")
        },
        {
            type: TwitterProfile,
            slug: "genopets",
            subscriberCount: 159500,
            subscriberCountEstimatedAt: new Date("2022-04-13")
        },
        {
            type: InstagramProfile,
            slug: "genopets",
            subscriberCount: 10800,
            subscriberCountEstimatedAt: new Date("2022-04-15")
        },
        {
            type: FacebookPage,
            slug: "Genopets.me",
            subscriberCount: 9590,
            subscriberCountEstimatedAt: new Date("2022-04-15")
        }, 
    ],
    tokens: [
        Genopets_GENE,
        Genopets_KI, 
    ],
    investors: todo([
        PanteraCapital, 
    ]),
    investorsCount: 17,
    products: [],
    roadmap: "https://docsend.com/view/b9bqd2j78nekzdgr",
    roadmapAvailableAt: already
});
var Aavegotchi = addGame({
    id: "Aavegotchi",
    name: "Aavegotchi",
    description: "Aavegotchi is a game where players manage little ghost NFTs.",
    image: "https://i.imgur.com/WQVTpQW.jpg",
    website: "https://www.aavegotchi.com/",
    docs: [
        "https://wiki.aavegotchi.com/"
    ],
    calculators: [],
    channels: [
        {
            type: DiscordServer,
            slug: "Aavegotchi",
            subscriberCount: 30417,
            subscriberCountEstimatedAt: new Date("2022-04-18")
        },
        {
            type: TwitterProfile,
            slug: "Aavegotchi",
            subscriberCount: 95800,
            subscriberCountEstimatedAt: new Date("2022-04-18")
        },
        {
            type: YouTubeChannel,
            slug: "Aavegotchi",
            subscriberCount: 1440,
            subscriberCountEstimatedAt: new Date("2022-04-18")
        },
        {
            type: TelegramGroup,
            slug: "Aavegotchi",
            subscriberCount: 10616,
            subscriberCountEstimatedAt: new Date("2022-04-18")
        },
        {
            type: RedditSubreddit,
            slug: "Aavegotchi",
            subscriberCount: 2300,
            subscriberCountEstimatedAt: new Date("2022-04-18")
        }, 
    ],
    tokens: todo([
        Aavegotchi_GHST, 
    ]),
    investors: todo([]),
    investorsCount: todo(0),
    products: [],
    roadmap: "https://aavegotchi.medium.com/aavegotchi-development-roadmap-v2-15820dcf84de",
    roadmapAvailableAt: already
});
var Stepn = addGame({
    id: "Stepn",
    name: "STEPN",
    description: "STEPN is a game where you get paid for running / walking in real life.",
    image: "https://i.imgur.com/9DKJD5v.png",
    website: "https://stepn.com/",
    docs: [
        "https://whitepaper.stepn.com/"
    ],
    calculators: [
        "https://stepn.wiki/",
        "https://stepn.guide/",
        "https://www.workitwallet.com/post/stepn-roi-calculator", 
    ],
    channels: [
        {
            type: TwitterProfile,
            slug: "Stepnofficial",
            subscriberCount: 269800,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        },
        {
            type: TelegramGroup,
            slug: "STEPNofficial",
            subscriberCount: 144609,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        },
        {
            type: DiscordServer,
            slug: "stepn",
            subscriberCount: 222201,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        },
        {
            type: InstagramProfile,
            slug: "stepncom",
            subscriberCount: 14700,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        },
        {
            type: MediumProfile,
            slug: "stepnofficial",
            subscriberCount: 8300,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        },
        {
            type: RedditSubreddit,
            slug: "StepN",
            subscriberCount: 16000,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        }, 
    ],
    tokens: [
        Stepn_GST,
        Stepn_GMT, 
    ],
    investors: todo([]),
    investorsCount: todo(0),
    products: [],
    roadmapAvailableAt: null
});
var Sorare = addGame({
    id: "Sorare",
    name: "Sorare",
    description: "Sorare is a fantasy football game where players buy, sell, trade, and manage a virtual team with NFT player cards.",
    image: "https://i.imgur.com/fUlRsLc.jpg",
    website: "https://sorare.com/",
    docs: [
        "https://help.sorare.com/"
    ],
    calculators: [
        "https://www.soraredata.com/", 
    ],
    channels: [
        {
            type: TwitterProfile,
            slug: "sorare",
            subscriberCount: 94600,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        },
        {
            type: TelegramGroup,
            slug: "SorareFC",
            subscriberCount: 3479,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        },
        {
            type: InstagramProfile,
            slug: "sorare",
            subscriberCount: 40700,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        },
        {
            type: DiscordServer,
            slug: "TSjtHaM",
            subscriberCount: 47074,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        },
        {
            type: RedditSubreddit,
            slug: "Sorare",
            subscriberCount: 7000,
            subscriberCountEstimatedAt: new Date("2022-04-19")
        }, 
    ],
    tokens: todo([]),
    investors: todo([]),
    investorsCount: todo(0),
    products: [],
    roadmap: todo("https://www.google.com/"),
    roadmapAvailableAt: todo(null)
});
var Decentraland = addGame({
    id: "Decentraland",
    name: "Decentraland",
    description: "",
    image: "https://i.imgur.com/poFVp7E.jpg",
    website: "https://decentraland.org/",
    docs: [],
    calculators: [],
    channels: todo([]),
    tokens: todo([]),
    investors: todo([]),
    investorsCount: todo(0),
    products: [],
    roadmap: todo("https://www.google.com/"),
    roadmapAvailableAt: todo(null)
});
var Letmespeak = addGame({
    id: "Letmespeak",
    name: "Letmespeak",
    description: "Learn to earn game where you can improve your english skill level",
    image: "https://i.imgur.com/wC5zz92.png",
    website: "https://www.letmespeak.org/",
    docs: [
        "https://letmespeak.medium.com/let-me-speak-economic-model-f95a31ae0ef8"
    ],
    calculators: [],
    channels: [
        {
            type: TwitterProfile,
            slug: "Letmespeak_org",
            subscriberCount: 987000,
            subscriberCountEstimatedAt: new Date("2022-04-26")
        },
        {
            type: TelegramGroup,
            slug: "letmespeak_org",
            subscriberCount: 100500,
            subscriberCountEstimatedAt: new Date("2022-04-26")
        },
        {
            type: InstagramProfile,
            slug: "letmespeak_org",
            subscriberCount: 113000,
            subscriberCountEstimatedAt: new Date("2022-04-26")
        },
        {
            type: DiscordServer,
            slug: "letmespeak",
            subscriberCount: 5800,
            subscriberCountEstimatedAt: new Date("2022-04-26")
        }, 
    ],
    tokens: todo([
        Letmespeak_LSTAR, 
    ]),
    investors: todo([]),
    investorsCount: todo(0),
    products: [],
    roadmapAvailableAt: todo(null)
});

;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Row.js




const Row_DEVICE_SIZES = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const Row = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'row');
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  Row_DEVICE_SIZES.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;

    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }

    const infix = brkPoint !== 'xs' ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ var esm_Row = (Row);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(6611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(9602);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(9059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(5005);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
;// CONCATENATED MODULE: ./components/GameCard.tsx






function GameCard(props) {
    var game = props.game;
    var discord = game.channels.find(function(channel) {
        return (0,lodash.isEqual)(channel.type, DiscordServer);
    });
    var subsCount = discord ? discord.subscriberCount : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Card, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Card.Img, {
                variant: "top",
                src: game.image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Card.Body, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Card.Title, {
                        children: game.name
                    }),
                    game.description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Card.Text, {
                        children: game.description
                    }) : undefined,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Discord: ",
                            subsCount
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/play-to-earn/games/".concat(game.id),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "primary",
                            children: "Learn more"
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/play-to-earn/games.tsx











var __N_SSG = true;
function PlayToEarnGames(props) {
    // const { } = props
    var t = (0,esm/* useTranslation */.$G)(translationNamespaces).t;
    var tc = (0,i18next/* withNamespace */.Q)(t, "common");
    var title = t("title");
    var description = t("description");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: (layout_module_default()).main,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (guides_module_default()).instructionSubheader,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Row, {
                    xs: 1,
                    md: 2,
                    lg: 3,
                    children: allGames.map(function(game) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Col, {
                            className: "g-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCard, {
                                game: game
                            })
                        }, game.id);
                    })
                })
            })
        ]
    });
};
var translationNamespaces = [
    "play-to-earn-games",
    "play-to-earn",
    "common"
];


/***/ }),

/***/ 7469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KI": function() { return /* binding */ IdSchema; },
/* harmony export */   "hH": function() { return /* binding */ fromStringToId; }
/* harmony export */ });
/* unused harmony exports idAllowedSymbols, validateId, byId, getById, toSystemId */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1604);
/* harmony import */ var _util_src_ensure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6600);


var idAllowedSymbols = [
    "\\w",
    "\\d",
    "-",
    "_",
    ".",
    ":"
];
var idAllowedSymbolsEscapedString = idAllowedSymbols.join("");
var idRegExp = new RegExp("^[".concat(idAllowedSymbolsEscapedString, "]+$"));
var idReplaceUnwantedCharactersRegExp = new RegExp("[^".concat(idAllowedSymbolsEscapedString, "]"), "g");
var IdSchema = zod__WEBPACK_IMPORTED_MODULE_1__.z.string().min(1).regex(idRegExp);
function validateId(id) {
    return IdSchema.parse(id);
}
function byId(id) {
    return function(object) {
        return object.id === id;
    };
}
function getById(objects, id) {
    return ensure(objects.find(byId(id)), err("Cannot get object by id: ".concat(id)));
}
function fromStringToId(string) {
    return string.replace(idReplaceUnwantedCharactersRegExp, "");
}
function toSystemId(id) {
    return id.replace(/\s+/g, "_");
}


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ UrlSchema; }
/* harmony export */ });
/* unused harmony export validateUrl */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1604);

var UrlSchema = zod__WEBPACK_IMPORTED_MODULE_0__.z.string().url().min(1);
function validateUrl(url) {
    return UrlSchema.parse(url);
}


/***/ }),

/***/ 9786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ie": function() { return /* binding */ UrlPatternSchema; },
/* harmony export */   "UV": function() { return /* binding */ substitutionRegExp; }
/* harmony export */ });
/* unused harmony exports UrlPatternsSchema, UrlPatternUidSchema, parseUrlPattern, parseUrlPatterns, parseUrlPatternUid */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1604);
/* harmony import */ var src_util_src_zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6338);
/* harmony import */ var _Url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7117);



var substitutionRegExp = /\{\{[^}]+\}\}/;
var UrlPatternSchema = _Url__WEBPACK_IMPORTED_MODULE_1__/* .UrlSchema.regex */ .z.regex(substitutionRegExp);
var UrlPatternsSchema = zod__WEBPACK_IMPORTED_MODULE_2__.z.array(UrlPatternSchema).superRefine((0,src_util_src_zod__WEBPACK_IMPORTED_MODULE_0__/* .getDuplicatesRefinement */ .$K)("UrlPattern", parseUrlPatternUid));
var UrlPatternUidSchema = _Url__WEBPACK_IMPORTED_MODULE_1__/* .UrlSchema */ .z;
function parseUrlPattern(urlPattern) {
    return UrlPatternSchema.parse(urlPattern);
}
function parseUrlPatterns(urlPatterns) {
    return UrlPatternsSchema.parse(urlPatterns);
}
function parseUrlPatternUid(urlPatternUid) {
    return UrlPatternUidSchema.parse(urlPatternUid);
}


/***/ }),

/***/ 6600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ err; },
/* harmony export */   "zx": function() { return /* binding */ ensure; }
/* harmony export */ });
/* unused harmony exports defaultCollectionFindThrowback, ensureStatic, checkAll, ensureFind, tb */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err1) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err1);
            }
            _next(undefined);
        });
    };
}


var defaultCollectionFindThrowback = function() {
    throw new Error("Can't find object in collection");
};
var err = function(message) {
    return function() {
        throw new Error(message);
    };
};
function ensure(object) {
    var throwback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultCollectionFindThrowback;
    if (object === null || object === undefined) {
        throw throwback();
    } else {
        return object;
    }
}
function ensureStatic(object, error) {
    if (object === null || object === undefined) {
        throw error !== null && error !== void 0 ? error : new Error("Can't find object in collection");
    } else {
        return object;
    }
}
function checkAll(objects) {
    if (!objects.every(identity)) {
        throw new Error("Some objects are falsy: \n\n".concat(JSON.stringify(objects)));
    } else {
        return objects;
    }
}
function ensureFind(collection, filter, error) {
    var object = collection.find(filter);
    if (object === null || object === undefined) {
        throw error !== null && error !== void 0 ? error : new Error("Can't find an object in a collection using filter: " + filter.toString());
    } else {
        return object;
    }
}
var tb = function(err2) {
    return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", err2);
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};


/***/ }),

/***/ 4873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ withNamespace; }
/* harmony export */ });
function withNamespace(t, ns) {
    return function(key) {
        return t(key, {
            ns: ns
        });
    };
}


/***/ }),

/***/ 146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jQ": function() { return /* binding */ nail; }
/* harmony export */ });
/* unused harmony exports indent, replaceInFirstLine, getLines */
/**
 * Removes spaces at the beginning of each line (allows to indent multiline strings in code, then remove this indent via `nail()` call)
 * @see ./string.test.ts
 */ function nail(str) {
    var spacesAtStart = str.match(/^\n(\s+)/);
    if (spacesAtStart) {
        return str.replace(new RegExp("^[^\\S\r\n]{0,".concat(spacesAtStart[1].length, "}"), "gm"), "");
    } else {
        return str;
    }
}
function indent(count, str) {
    var padding = " ".repeat(count);
    return str.split("\n").map(function(s) {
        return padding + s;
    }).join("\n");
}
function replaceInFirstLine(haystack, needle, replacement) {
    var lines = haystack.split("\n");
    lines[0] = lines[0].replace(needle, replacement);
    return lines.join("\n");
}
function getLines(text) {
    return text.split("\n");
}


/***/ }),

/***/ 2927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RY": function() { return /* binding */ toUidFromSchema; },
/* harmony export */   "dP": function() { return /* binding */ byUid; }
/* harmony export */ });
/* unused harmony exports toUid, fromUid */
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3549);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6388);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function toUid(obj) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return pick.apply(void 0, [
        obj
    ].concat(_toConsumableArray(keys)));
}
function toUidFromSchema(obj, schema) {
    return lodash_es__WEBPACK_IMPORTED_MODULE_0__/* ["default"].apply */ .Z.apply(void 0, [
        obj
    ].concat(_toConsumableArray(Object.keys(schema.shape))));
}
// export function toUid<T>(array: Array<T>): string {
//   return JSON.stringify(array)
// }
function fromUid(uid) {
    return JSON.parse(uid);
}
function byUid(getUid, holder) {
    var uid = getUid(holder);
    // console.log('uid', uid)
    return function($obj) {
        var $uid = getUid($obj);
        // console.log('$uid', $uid)
        return (0,lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(uid, $uid);
    };
} // export function getCompositeUid<O extends Record<string, unknown>>(object: O, map: Record<keyof O, GetUid<unknown>>) {
 //   return JSON.stringify(Object.assign({}, object, { items: schedule.items.map(getScheduleItemUid) }))
 // }


/***/ }),

/***/ 6338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$K": function() { return /* binding */ getDuplicatesRefinement; },
  "QC": function() { return /* binding */ getFinder; },
  "VE": function() { return /* binding */ getInserter; },
  "oY": function() { return /* binding */ getName; }
});

// UNUSED EXPORTS: getDuplicateStats, getErrorReports, getGenericInserter, getMultiInserter, getUniqueCountStats, insert, mustIncludeAllOf, parse, parseWithSchema

// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEqual.js + 43 modules
var isEqual = __webpack_require__(6388);
;// CONCATENATED MODULE: ./src/util/src/lodash.ts

function isEqualBy(a, b, getter) {
    return (0,isEqual/* default */.Z)(getter(a), getter(b));
}
function isSubset(set, subset) {
    return difference(set, subset).length === 0;
}
function mergeWithArrays(object, source1, source2) {
    return mergeWith(object, source1, source2, function(a, b) {
        if (isArray(a) && isArray(b)) {
            return b.concat(a);
        }
    });
}
var notInBy = function(getUid) {
    return function(elements) {
        return function(element) {
            return !elements.find(function(el) {
                return isEqualBy(el, element, getUid);
            });
        };
    };
};

// EXTERNAL MODULE: ./src/util/src/uid.ts
var uid = __webpack_require__(2927);
// EXTERNAL MODULE: ./src/util/src/ensure.ts
var ensure = __webpack_require__(6600);
;// CONCATENATED MODULE: ./src/util/src/zod.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





function getDuplicatesRefinement(name, getUniqueValue) {
    return function(objects, context) {
        var stats = getDuplicateStats(objects, getUniqueValue);
        stats.map(function(err1) {
            return context.addIssue({
                code: lib/* ZodIssueCode.custom */.NL.custom,
                params: err1,
                message: "Found ".concat(name, " duplicates: ").concat(JSON.stringify(err1))
            });
        });
    };
}
function getDuplicateStats(objects, getUniqueValue) {
    var stats = getUniqueCountStats(objects, getUniqueValue);
    return stats.filter(function(stat) {
        return stat.count > 1;
    });
}
function getUniqueCountStats(objects, getUniqueValue) {
    var stats1 = [];
    return objects.reduce(function(stats, value) {
        var uid = getUniqueValue(value);
        var index = stats.findIndex(function(s) {
            return (0,isEqual/* default */.Z)(s.uid, uid);
        });
        if (~index) {
            stats[index].count++;
        } else {
            stats.push({
                uid: uid,
                count: 1
            });
        }
        return stats;
    }, stats1);
}
var insert = function(name) {
    return function(schema) {
        return function(getUid) {
            return function(array) {
                return function(object) {
                    var $object = schema.parse(object);
                    var duplicate = array.find(function(o) {
                        return isEqualBy(o, $object, getUid);
                    });
                    if (duplicate) throw new Error("Duplicate ".concat(name, " found: ").concat(JSON.stringify(getUid(duplicate))));
                    array.push($object);
                    return $object;
                };
            };
        };
    };
};
function getGenericInserter(name, schema, getUid) {
    return insert(name)(schema)(getUid);
}
function getInserter(name, schema, getUid, array) {
    return insert(name)(schema)(getUid)(array);
}
function getMultiInserter(name, schema, getUid, array) {
    var inserter = insert(name)(schema)(getUid)(array);
    return function(objects) {
        return objects.map(inserter);
    };
}
function getFinder(getUid, array) {
    return function(uidHolder) {
        return array.find((0,uid/* byUid */.dP)(getUid, uidHolder));
    };
}
function parse(schema, input) {
    var result = schema.safeParse(input);
    if (result.success) {
        return result.data;
    } else {
        console.error("input", input);
        throw result.error;
    }
}
function getName(schema) {
    var description = (0,ensure/* ensure */.zx)(schema.description, (0,ensure/* err */.cn)("Cannot get schema name: ".concat(JSON.stringify(schema))));
    var ref = _slicedToArray(description.split(" "), 1), name = ref[0];
    return name;
}
var mustIncludeAllOf = function(required) {
    return function(elements) {
        return difference(required, elements).length === 0;
    };
};
function getErrorReports(results, schema) {
    var errors = results.reduce(function(reports, result, index) {
        if (result.success) {
            return reports;
        } else {
            var report = {
                index: index,
                error: result.error
            };
            return reports.concat([
                report
            ]);
        }
    }, []);
    return errors;
}
function parseWithSchema(objects, schema) {
    var results = objects.map(function(b) {
        return schema.safeParse(b);
    });
    return results.map(function(result, index) {
        if (result.success) {
            return result.data;
        } else {
            throw {
                index: index,
                error: result.error
            };
        }
    });
}


/***/ }),

/***/ 1775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"instruction-header":"guides_instruction-header__FBi6Z","instruction-subheader":"guides_instruction-subheader__9Md2b"};

/***/ }),

/***/ 7272:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__5R52X","hero":"layout_hero__sdPiy","main":"layout_main__j5lor","footer":"layout_footer__a_vOy","title":"layout_title__zDlUa","subtitle":"layout_subtitle__Wt4qK","code":"layout_code__EMwy8","grid":"layout_grid__gVdal","card":"layout_card__dnilS","logo":"layout_logo__ZuUu7","list":"layout_list__0_v1E"};

/***/ }),

/***/ 3689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "decode": function() { return /* binding */ decode; },
/* harmony export */   "encode": function() { return /* binding */ encode; },
/* harmony export */   "toASCII": function() { return /* binding */ toASCII; },
/* harmony export */   "toUnicode": function() { return /* binding */ toUnicode; },
/* harmony export */   "ucs2decode": function() { return /* binding */ ucs2decode; },
/* harmony export */   "ucs2encode": function() { return /* binding */ ucs2encode; }
/* harmony export */ });


/** Highest positive signed 32-bit float value */
const maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */
const base = 36;
const tMin = 1;
const tMax = 26;
const skew = 38;
const damp = 700;
const initialBias = 72;
const initialN = 128; // 0x80
const delimiter = '-'; // '\x2D'

/** Regular expressions */
const regexPunycode = /^xn--/;
const regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
const regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */
const errors = {
	'overflow': 'Overflow: input needs wider integers to process',
	'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
	'invalid-input': 'Invalid input'
};

/** Convenience shortcuts */
const baseMinusTMin = base - tMin;
const floor = Math.floor;
const stringFromCharCode = String.fromCharCode;

/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */
function error(type) {
	throw new RangeError(errors[type]);
}

/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */
function map(array, fn) {
	const result = [];
	let length = array.length;
	while (length--) {
		result[length] = fn(array[length]);
	}
	return result;
}

/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */
function mapDomain(string, fn) {
	const parts = string.split('@');
	let result = '';
	if (parts.length > 1) {
		// In email addresses, only the domain name should be punycoded. Leave
		// the local part (i.e. everything up to `@`) intact.
		result = parts[0] + '@';
		string = parts[1];
	}
	// Avoid `split(regex)` for IE8 compatibility. See #17.
	string = string.replace(regexSeparators, '\x2E');
	const labels = string.split('.');
	const encoded = map(labels, fn).join('.');
	return result + encoded;
}

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */
function ucs2decode(string) {
	const output = [];
	let counter = 0;
	const length = string.length;
	while (counter < length) {
		const value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// It's a high surrogate, and there is a next character.
			const extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// It's an unmatched surrogate; only append this code unit, in case the
				// next code unit is the high surrogate of a surrogate pair.
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */
const ucs2encode = array => String.fromCodePoint(...array);

/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */
const basicToDigit = function(codePoint) {
	if (codePoint - 0x30 < 0x0A) {
		return codePoint - 0x16;
	}
	if (codePoint - 0x41 < 0x1A) {
		return codePoint - 0x41;
	}
	if (codePoint - 0x61 < 0x1A) {
		return codePoint - 0x61;
	}
	return base;
};

/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */
const digitToBasic = function(digit, flag) {
	//  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */
const adapt = function(delta, numPoints, firstTime) {
	let k = 0;
	delta = firstTime ? floor(delta / damp) : delta >> 1;
	delta += floor(delta / numPoints);
	for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
		delta = floor(delta / baseMinusTMin);
	}
	return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */
const decode = function(input) {
	// Don't use UCS-2.
	const output = [];
	const inputLength = input.length;
	let i = 0;
	let n = initialN;
	let bias = initialBias;

	// Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.

	let basic = input.lastIndexOf(delimiter);
	if (basic < 0) {
		basic = 0;
	}

	for (let j = 0; j < basic; ++j) {
		// if it's not a basic code point
		if (input.charCodeAt(j) >= 0x80) {
			error('not-basic');
		}
		output.push(input.charCodeAt(j));
	}

	// Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.

	for (let index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

		// `index` is the index of the next character to be consumed.
		// Decode a generalized variable-length integer into `delta`,
		// which gets added to `i`. The overflow checking is easier
		// if we increase `i` as we go, then subtract off its starting
		// value at the end to obtain `delta`.
		let oldi = i;
		for (let w = 1, k = base; /* no condition */; k += base) {

			if (index >= inputLength) {
				error('invalid-input');
			}

			const digit = basicToDigit(input.charCodeAt(index++));

			if (digit >= base || digit > floor((maxInt - i) / w)) {
				error('overflow');
			}

			i += digit * w;
			const t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

			if (digit < t) {
				break;
			}

			const baseMinusT = base - t;
			if (w > floor(maxInt / baseMinusT)) {
				error('overflow');
			}

			w *= baseMinusT;

		}

		const out = output.length + 1;
		bias = adapt(i - oldi, out, oldi == 0);

		// `i` was supposed to wrap around from `out` to `0`,
		// incrementing `n` each time, so we'll fix that now:
		if (floor(i / out) > maxInt - n) {
			error('overflow');
		}

		n += floor(i / out);
		i %= out;

		// Insert `n` at position `i` of the output.
		output.splice(i++, 0, n);

	}

	return String.fromCodePoint(...output);
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */
const encode = function(input) {
	const output = [];

	// Convert the input in UCS-2 to an array of Unicode code points.
	input = ucs2decode(input);

	// Cache the length.
	let inputLength = input.length;

	// Initialize the state.
	let n = initialN;
	let delta = 0;
	let bias = initialBias;

	// Handle the basic code points.
	for (const currentValue of input) {
		if (currentValue < 0x80) {
			output.push(stringFromCharCode(currentValue));
		}
	}

	let basicLength = output.length;
	let handledCPCount = basicLength;

	// `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.

	// Finish the basic string with a delimiter unless it's empty.
	if (basicLength) {
		output.push(delimiter);
	}

	// Main encoding loop:
	while (handledCPCount < inputLength) {

		// All non-basic code points < n have been handled already. Find the next
		// larger one:
		let m = maxInt;
		for (const currentValue of input) {
			if (currentValue >= n && currentValue < m) {
				m = currentValue;
			}
		}

		// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
		// but guard against overflow.
		const handledCPCountPlusOne = handledCPCount + 1;
		if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
			error('overflow');
		}

		delta += (m - n) * handledCPCountPlusOne;
		n = m;

		for (const currentValue of input) {
			if (currentValue < n && ++delta > maxInt) {
				error('overflow');
			}
			if (currentValue == n) {
				// Represent delta as a generalized variable-length integer.
				let q = delta;
				for (let k = base; /* no condition */; k += base) {
					const t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
					if (q < t) {
						break;
					}
					const qMinusT = q - t;
					const baseMinusT = base - t;
					output.push(
						stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
					);
					q = floor(qMinusT / baseMinusT);
				}

				output.push(stringFromCharCode(digitToBasic(q, 0)));
				bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
				delta = 0;
				++handledCPCount;
			}
		}

		++delta;
		++n;

	}
	return output.join('');
};

/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */
const toUnicode = function(input) {
	return mapDomain(input, function(string) {
		return regexPunycode.test(string)
			? decode(string.slice(4).toLowerCase())
			: string;
	});
};

/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */
const toASCII = function(input) {
	return mapDomain(input, function(string) {
		return regexNonASCII.test(string)
			? 'xn--' + encode(string)
			: string;
	});
};

/*--------------------------------------------------------------------------*/

/** Define the public API */
const punycode = {
	/**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */
	'version': '2.1.0',
	/**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */
	'ucs2': {
		'decode': ucs2decode,
		'encode': ucs2encode
	},
	'decode': decode,
	'encode': encode,
	'toASCII': toASCII,
	'toUnicode': toUnicode
};


/* harmony default export */ __webpack_exports__["default"] = (punycode);


/***/ }),

/***/ 5005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var _SafeAnchor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8358);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





const defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false
};
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  variant,
  size,
  active,
  className,
  type,
  as,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn');
  const classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`);

  if (props.href) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_SafeAnchor__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { ...props,
      as: as,
      ref: ref,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(classes, props.disabled && 'disabled')
    });
  }

  if (!type && !as) {
    type = 'button';
  }

  const Component = as || 'button';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...props,
    ref: ref,
    type: type,
    className: classes
  });
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 9602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);



/* harmony default export */ __webpack_exports__["Z"] = (className => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((p, ref) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", { ...p,
  ref: ref,
  className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(p.className, className)
})));

/***/ }),

/***/ 2678:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"ad":true,"ae":true,"af":true,"ag":true,"ai":true,"al":true,"am":true,"ao":true,"aq":true,"ar":true,"as":true,"at":true,"au":true,"aw":true,"ax":true,"az":true,"ba":true,"bb":true,"bd":true,"be":true,"bf":true,"bg":true,"bh":true,"bi":true,"bj":true,"bl":true,"bm":true,"bn":true,"bo":true,"bq":true,"br":true,"bs":true,"bt":true,"bv":true,"bw":true,"by":true,"bz":true,"ca":true,"cc":true,"cd":true,"cf":true,"cg":true,"ch":true,"ci":true,"ck":true,"cl":true,"cm":true,"cn":true,"co":true,"cr":true,"cu":true,"cv":true,"cw":true,"cx":true,"cy":true,"cz":true,"de":true,"dj":true,"dk":true,"dm":true,"do":true,"dz":true,"ec":true,"ee":true,"eg":true,"er":true,"es":true,"et":true,"fi":true,"fj":true,"fk":true,"fm":true,"fo":true,"fr":true,"ga":true,"gb (.uk)":true,"gd":true,"ge":true,"gf":true,"gg":true,"gh":true,"gi":true,"gl":true,"gm":true,"gn":true,"gp":true,"gq":true,"gr":true,"gs":true,"gt":true,"gu":true,"gw":true,"gy":true,"hk":true,"hm":true,"hn":true,"hr":true,"ht":true,"hu":true,"id":true,"ie":true,"il":true,"im":true,"in":true,"io":true,"iq":true,"ir":true,"is":true,"it":true,"je":true,"jm":true,"jo":true,"jp":true,"ke":true,"kg":true,"kh":true,"ki":true,"km":true,"kn":true,"kp":true,"kr":true,"kw":true,"ky":true,"kz":true,"la":true,"lb":true,"lc":true,"li":true,"lk":true,"lr":true,"ls":true,"lt":true,"lu":true,"lv":true,"ly":true,"ma":true,"mc":true,"md":true,"me":true,"mf":true,"mg":true,"mh":true,"mk":true,"ml":true,"mm":true,"mn":true,"mo":true,"mp":true,"mq":true,"mr":true,"ms":true,"mt":true,"mu":true,"mv":true,"mw":true,"mx":true,"my":true,"mz":true,"na":true,"nc":true,"ne":true,"nf":true,"ng":true,"ni":true,"nl":true,"no":true,"np":true,"nr":true,"nu":true,"nz":true,"om":true,"pa":true,"pe":true,"pf":true,"pg":true,"ph":true,"pk":true,"pl":true,"pm":true,"pn":true,"pr":true,"ps":true,"pt":true,"pw":true,"py":true,"qa":true,"re":true,"ro":true,"rs":true,"ru":true,"rw":true,"sa":true,"sb":true,"sc":true,"sd":true,"se":true,"sg":true,"sh":true,"si":true,"sj":true,"sk":true,"sl":true,"sm":true,"sn":true,"so":true,"sr":true,"ss":true,"st":true,"sv":true,"sx":true,"sy":true,"sz":true,"tc":true,"td":true,"tf":true,"tg":true,"th":true,"tj":true,"tk":true,"tl":true,"tm":true,"tn":true,"to":true,"tr":true,"tt":true,"tv":true,"tw":true,"tz":true,"ua":true,"ug":true,"us":true,"uy":true,"uz":true,"va":true,"vc":true,"ve":true,"vg":true,"vi":true,"vn":true,"vu":true,"wf":true,"ws":true,"ye":true,"yt":true,"za":true,"zm":true,"zw":true}');

/***/ }),

/***/ 7086:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"com.ac":true,"net.ac":true,"gov.ac":true,"org.ac":true,"mil.ac":true,"co.ae":true,"net.ae":true,"gov.ae":true,"ac.ae":true,"sch.ae":true,"org.ae":true,"mil.ae":true,"pro.ae":true,"name.ae":true,"com.af":true,"edu.af":true,"gov.af":true,"net.af":true,"org.af":true,"com.al":true,"edu.al":true,"gov.al":true,"mil.al":true,"net.al":true,"org.al":true,"ed.ao":true,"gv.ao":true,"og.ao":true,"co.ao":true,"pb.ao":true,"it.ao":true,"com.ar":true,"edu.ar":true,"gob.ar":true,"gov.ar":true,"int.ar":true,"mil.ar":true,"net.ar":true,"org.ar":true,"tur.ar":true,"gv.at":true,"ac.at":true,"co.at":true,"or.at":true,"com.au":true,"net.au":true,"org.au":true,"edu.au":true,"gov.au":true,"csiro.au":true,"asn.au":true,"id.au":true,"vic.au":true,"sa.au":true,"wa.au":true,"nt.au":true,"tas.au":true,"qld.au":true,"act.au":true,"conf.au":true,"oz.au":true,"org.ba":true,"net.ba":true,"edu.ba":true,"gov.ba":true,"mil.ba":true,"unsa.ba":true,"untz.ba":true,"unmo.ba":true,"unbi.ba":true,"unze.ba":true,"co.ba":true,"com.ba":true,"rs.ba":true,"co.bb":true,"com.bb":true,"net.bb":true,"org.bb":true,"gov.bb":true,"edu.bb":true,"info.bb":true,"store.bb":true,"tv.bb":true,"biz.bb":true,"com.bh":true,"info.bh":true,"cc.bh":true,"edu.bh":true,"biz.bh":true,"net.bh":true,"org.bh":true,"gov.bh":true,"com.bn":true,"edu.bn":true,"gov.bn":true,"net.bn":true,"org.bn":true,"com.bo":true,"net.bo":true,"org.bo":true,"tv.bo":true,"mil.bo":true,"int.bo":true,"gob.bo":true,"gov.bo":true,"edu.bo":true,"adm.br":true,"adv.br":true,"agr.br":true,"am.br":true,"arq.br":true,"art.br":true,"ato.br":true,"b.br":true,"bio.br":true,"blog.br":true,"bmd.br":true,"cim.br":true,"cng.br":true,"cnt.br":true,"com.br":true,"coop.br":true,"ecn.br":true,"edu.br":true,"eng.br":true,"esp.br":true,"etc.br":true,"eti.br":true,"far.br":true,"flog.br":true,"fm.br":true,"fnd.br":true,"fot.br":true,"fst.br":true,"g12.br":true,"ggf.br":true,"gov.br":true,"imb.br":true,"ind.br":true,"inf.br":true,"jor.br":true,"jus.br":true,"lel.br":true,"mat.br":true,"med.br":true,"mil.br":true,"mus.br":true,"net.br":true,"nom.br":true,"not.br":true,"ntr.br":true,"odo.br":true,"org.br":true,"ppg.br":true,"pro.br":true,"psc.br":true,"psi.br":true,"qsl.br":true,"rec.br":true,"slg.br":true,"srv.br":true,"tmp.br":true,"trd.br":true,"tur.br":true,"tv.br":true,"vet.br":true,"vlog.br":true,"wiki.br":true,"zlg.br":true,"com.bs":true,"net.bs":true,"org.bs":true,"edu.bs":true,"gov.bs":true,"om.bz":true,"du.bz":true,"ov.bz":true,"et.bz":true,"rg.bz":true,"ab.ca":true,"bc.ca":true,"mb.ca":true,"nb.ca":true,"nf.ca":true,"nl.ca":true,"ns.ca":true,"nt.ca":true,"nu.ca":true,"on.ca":true,"pe.ca":true,"qc.ca":true,"sk.ca":true,"yk.ca":true,"co.ck":true,"org.ck":true,"edu.ck":true,"gov.ck":true,"net.ck":true,"gen.ck":true,"biz.ck":true,"info.ck":true,"ac.cn":true,"com.cn":true,"edu.cn":true,"gov.cn":true,"mil.cn":true,"net.cn":true,"org.cn":true,"ah.cn":true,"bj.cn":true,"cq.cn":true,"fj.cn":true,"gd.cn":true,"gs.cn":true,"gz.cn":true,"gx.cn":true,"ha.cn":true,"hb.cn":true,"he.cn":true,"hi.cn":true,"hl.cn":true,"hn.cn":true,"jl.cn":true,"js.cn":true,"jx.cn":true,"ln.cn":true,"nm.cn":true,"nx.cn":true,"qh.cn":true,"sc.cn":true,"sd.cn":true,"sh.cn":true,"sn.cn":true,"sx.cn":true,"tj.cn":true,"tw.cn":true,"xj.cn":true,"xz.cn":true,"yn.cn":true,"zj.cn":true,"com.co":true,"org.co":true,"edu.co":true,"gov.co":true,"net.co":true,"mil.co":true,"nom.co":true,"ac.cr":true,"co.cr":true,"ed.cr":true,"fi.cr":true,"go.cr":true,"or.cr":true,"sa.cr":true,"cr":true,"ac.cy":true,"net.cy":true,"gov.cy":true,"org.cy":true,"pro.cy":true,"name.cy":true,"ekloges.cy":true,"tm.cy":true,"ltd.cy":true,"biz.cy":true,"press.cy":true,"parliament.cy":true,"com.cy":true,"edu.do":true,"gob.do":true,"gov.do":true,"com.do":true,"sld.do":true,"org.do":true,"net.do":true,"web.do":true,"mil.do":true,"art.do":true,"com.dz":true,"org.dz":true,"net.dz":true,"gov.dz":true,"edu.dz":true,"asso.dz":true,"pol.dz":true,"art.dz":true,"com.ec":true,"info.ec":true,"net.ec":true,"fin.ec":true,"med.ec":true,"pro.ec":true,"org.ec":true,"edu.ec":true,"gov.ec":true,"mil.ec":true,"com.eg":true,"edu.eg":true,"eun.eg":true,"gov.eg":true,"mil.eg":true,"name.eg":true,"net.eg":true,"org.eg":true,"sci.eg":true,"com.er":true,"edu.er":true,"gov.er":true,"mil.er":true,"net.er":true,"org.er":true,"ind.er":true,"rochest.er":true,"w.er":true,"com.es":true,"nom.es":true,"org.es":true,"gob.es":true,"edu.es":true,"com.et":true,"gov.et":true,"org.et":true,"edu.et":true,"net.et":true,"biz.et":true,"name.et":true,"info.et":true,"ac.fj":true,"biz.fj":true,"com.fj":true,"info.fj":true,"mil.fj":true,"name.fj":true,"net.fj":true,"org.fj":true,"pro.fj":true,"co.fk":true,"org.fk":true,"gov.fk":true,"ac.fk":true,"nom.fk":true,"net.fk":true,"fr":true,"tm.fr":true,"asso.fr":true,"nom.fr":true,"prd.fr":true,"presse.fr":true,"com.fr":true,"gouv.fr":true,"co.gg":true,"net.gg":true,"org.gg":true,"com.gh":true,"edu.gh":true,"gov.gh":true,"org.gh":true,"mil.gh":true,"co.gl":true,"com.gl":true,"edu.gl":true,"net.gl":true,"org.gl":true,"com.gn":true,"ac.gn":true,"gov.gn":true,"org.gn":true,"net.gn":true,"com.gr":true,"edu.gr":true,"net.gr":true,"org.gr":true,"gov.gr":true,"mil.gr":true,"com.gt":true,"edu.gt":true,"net.gt":true,"gob.gt":true,"org.gt":true,"mil.gt":true,"ind.gt":true,"com.gu":true,"net.gu":true,"gov.gu":true,"org.gu":true,"edu.gu":true,"com.hk":true,"edu.hk":true,"gov.hk":true,"idv.hk":true,"net.hk":true,"org.hk":true,"2000.hu":true,"agrar.hu":true,"bolt.hu":true,"casino.hu":true,"city.hu":true,"co.hu":true,"erotica.hu":true,"erotika.hu":true,"film.hu":true,"forum.hu":true,"games.hu":true,"hotel.hu":true,"info.hu":true,"ingatlan.hu":true,"jogasz.hu":true,"konyvelo.hu":true,"lakas.hu":true,"media.hu":true,"news.hu":true,"org.hu":true,"priv.hu":true,"reklam.hu":true,"sex.hu":true,"shop.hu":true,"sport.hu":true,"suli.huv":true,"szex.hu":true,"tm.hu":true,"tozsde.hu":true,"utazas.hu":true,"video.hu":true,"ac.id":true,"co.id":true,"net.id":true,"or.id":true,"web.id":true,"sch.id":true,"mil.id":true,"go.id":true,"war.net.id":true,"my.id":true,"biz.id":true,"ac.il":true,"co.il":true,"org.il":true,"net.il":true,"k12.il":true,"gov.il":true,"muni.il":true,"idf.il":true,"in":true,"4fd.in":true,"co.in":true,"firm.in":true,"net.in":true,"org.in":true,"gen.in":true,"ind.in":true,"ac.in":true,"edu.in":true,"res.in":true,"ernet.in":true,"gov.in":true,"mil.in":true,"nic.in":true,"iq":true,"gov.iq":true,"edu.iq":true,"com.iq":true,"mil.iq":true,"org.iq":true,"net.iq":true,"ir":true,"ac.ir":true,"co.ir":true,"gov.ir":true,"id.ir":true,"net.ir":true,"org.ir":true,"sch.ir":true,"dnssec.ir":true,"gov.it":true,"edu.it":true,"co.je":true,"net.je":true,"org.je":true,"com.jo":true,"net.jo":true,"gov.jo":true,"edu.jo":true,"org.jo":true,"mil.jo":true,"name.jo":true,"sch.jo":true,"ac.jp":true,"ad.jp":true,"co.jp":true,"ed.jp":true,"go.jp":true,"gr.jp":true,"lg.jp":true,"ne.jp":true,"or.jp":true,"co.ke":true,"or.ke":true,"ne.ke":true,"go.ke":true,"ac.ke":true,"sc.ke":true,"me.ke":true,"mobi.ke":true,"info.ke":true,"per.kh":true,"com.kh":true,"edu.kh":true,"gov.kh":true,"mil.kh":true,"net.kh":true,"org.kh":true,"com.ki":true,"biz.ki":true,"de.ki":true,"net.ki":true,"info.ki":true,"org.ki":true,"gov.ki":true,"edu.ki":true,"mob.ki":true,"tel.ki":true,"km":true,"com.km":true,"coop.km":true,"asso.km":true,"nom.km":true,"presse.km":true,"tm.km":true,"medecin.km":true,"notaires.km":true,"pharmaciens.km":true,"veterinaire.km":true,"edu.km":true,"gouv.km":true,"mil.km":true,"net.kn":true,"org.kn":true,"edu.kn":true,"gov.kn":true,"kr":true,"co.kr":true,"ne.kr":true,"or.kr":true,"re.kr":true,"pe.kr":true,"go.kr":true,"mil.kr":true,"ac.kr":true,"hs.kr":true,"ms.kr":true,"es.kr":true,"sc.kr":true,"kg.kr":true,"seoul.kr":true,"busan.kr":true,"daegu.kr":true,"incheon.kr":true,"gwangju.kr":true,"daejeon.kr":true,"ulsan.kr":true,"gyeonggi.kr":true,"gangwon.kr":true,"chungbuk.kr":true,"chungnam.kr":true,"jeonbuk.kr":true,"jeonnam.kr":true,"gyeongbuk.kr":true,"gyeongnam.kr":true,"jeju.kr":true,"edu.kw":true,"com.kw":true,"net.kw":true,"org.kw":true,"gov.kw":true,"com.ky":true,"org.ky":true,"net.ky":true,"edu.ky":true,"gov.ky":true,"com.kz":true,"edu.kz":true,"gov.kz":true,"mil.kz":true,"net.kz":true,"org.kz":true,"com.lb":true,"edu.lb":true,"gov.lb":true,"net.lb":true,"org.lb":true,"gov.lk":true,"sch.lk":true,"net.lk":true,"int.lk":true,"com.lk":true,"org.lk":true,"edu.lk":true,"ngo.lk":true,"soc.lk":true,"web.lk":true,"ltd.lk":true,"assn.lk":true,"grp.lk":true,"hotel.lk":true,"com.lr":true,"edu.lr":true,"gov.lr":true,"org.lr":true,"net.lr":true,"com.lv":true,"edu.lv":true,"gov.lv":true,"org.lv":true,"mil.lv":true,"id.lv":true,"net.lv":true,"asn.lv":true,"conf.lv":true,"com.ly":true,"net.ly":true,"gov.ly":true,"plc.ly":true,"edu.ly":true,"sch.ly":true,"med.ly":true,"org.ly":true,"id.ly":true,"ma":true,"net.ma":true,"ac.ma":true,"org.ma":true,"gov.ma":true,"press.ma":true,"co.ma":true,"tm.mc":true,"asso.mc":true,"co.me":true,"net.me":true,"org.me":true,"edu.me":true,"ac.me":true,"gov.me":true,"its.me":true,"priv.me":true,"org.mg":true,"nom.mg":true,"gov.mg":true,"prd.mg":true,"tm.mg":true,"edu.mg":true,"mil.mg":true,"com.mg":true,"com.mk":true,"org.mk":true,"net.mk":true,"edu.mk":true,"gov.mk":true,"inf.mk":true,"name.mk":true,"pro.mk":true,"com.ml":true,"net.ml":true,"org.ml":true,"edu.ml":true,"gov.ml":true,"presse.ml":true,"gov.mn":true,"edu.mn":true,"org.mn":true,"com.mo":true,"edu.mo":true,"gov.mo":true,"net.mo":true,"org.mo":true,"com.mt":true,"org.mt":true,"net.mt":true,"edu.mt":true,"gov.mt":true,"aero.mv":true,"biz.mv":true,"com.mv":true,"coop.mv":true,"edu.mv":true,"gov.mv":true,"info.mv":true,"int.mv":true,"mil.mv":true,"museum.mv":true,"name.mv":true,"net.mv":true,"org.mv":true,"pro.mv":true,"ac.mw":true,"co.mw":true,"com.mw":true,"coop.mw":true,"edu.mw":true,"gov.mw":true,"int.mw":true,"museum.mw":true,"net.mw":true,"org.mw":true,"com.mx":true,"net.mx":true,"org.mx":true,"edu.mx":true,"gob.mx":true,"com.my":true,"net.my":true,"org.my":true,"gov.my":true,"edu.my":true,"sch.my":true,"mil.my":true,"name.my":true,"com.nf":true,"net.nf":true,"arts.nf":true,"store.nf":true,"web.nf":true,"firm.nf":true,"info.nf":true,"other.nf":true,"per.nf":true,"rec.nf":true,"com.ng":true,"org.ng":true,"gov.ng":true,"edu.ng":true,"net.ng":true,"sch.ng":true,"name.ng":true,"mobi.ng":true,"biz.ng":true,"mil.ng":true,"gob.ni":true,"co.ni":true,"com.ni":true,"ac.ni":true,"edu.ni":true,"org.ni":true,"nom.ni":true,"net.ni":true,"mil.ni":true,"com.np":true,"edu.np":true,"gov.np":true,"org.np":true,"mil.np":true,"net.np":true,"edu.nr":true,"gov.nr":true,"biz.nr":true,"info.nr":true,"net.nr":true,"org.nr":true,"com.nr":true,"com.om":true,"co.om":true,"edu.om":true,"ac.om":true,"sch.om":true,"gov.om":true,"net.om":true,"org.om":true,"mil.om":true,"museum.om":true,"biz.om":true,"pro.om":true,"med.om":true,"edu.pe":true,"gob.pe":true,"nom.pe":true,"mil.pe":true,"sld.pe":true,"org.pe":true,"com.pe":true,"net.pe":true,"com.ph":true,"net.ph":true,"org.ph":true,"mil.ph":true,"ngo.ph":true,"i.ph":true,"gov.ph":true,"edu.ph":true,"com.pk":true,"net.pk":true,"edu.pk":true,"org.pk":true,"fam.pk":true,"biz.pk":true,"web.pk":true,"gov.pk":true,"gob.pk":true,"gok.pk":true,"gon.pk":true,"gop.pk":true,"gos.pk":true,"pwr.pl":true,"com.pl":true,"biz.pl":true,"net.pl":true,"art.pl":true,"edu.pl":true,"org.pl":true,"ngo.pl":true,"gov.pl":true,"info.pl":true,"mil.pl":true,"waw.pl":true,"warszawa.pl":true,"wroc.pl":true,"wroclaw.pl":true,"krakow.pl":true,"katowice.pl":true,"poznan.pl":true,"lodz.pl":true,"gda.pl":true,"gdansk.pl":true,"slupsk.pl":true,"radom.pl":true,"szczecin.pl":true,"lublin.pl":true,"bialystok.pl":true,"olsztyn.pl":true,"torun.pl":true,"gorzow.pl":true,"zgora.pl":true,"biz.pr":true,"com.pr":true,"edu.pr":true,"gov.pr":true,"info.pr":true,"isla.pr":true,"name.pr":true,"net.pr":true,"org.pr":true,"pro.pr":true,"est.pr":true,"prof.pr":true,"ac.pr":true,"com.ps":true,"net.ps":true,"org.ps":true,"edu.ps":true,"gov.ps":true,"plo.ps":true,"sec.ps":true,"co.pw":true,"ne.pw":true,"or.pw":true,"ed.pw":true,"go.pw":true,"belau.pw":true,"arts.ro":true,"com.ro":true,"firm.ro":true,"info.ro":true,"nom.ro":true,"nt.ro":true,"org.ro":true,"rec.ro":true,"store.ro":true,"tm.ro":true,"www.ro":true,"co.rs":true,"org.rs":true,"edu.rs":true,"ac.rs":true,"gov.rs":true,"in.rs":true,"com.sb":true,"net.sb":true,"edu.sb":true,"org.sb":true,"gov.sb":true,"com.sc":true,"net.sc":true,"edu.sc":true,"gov.sc":true,"org.sc":true,"co.sh":true,"com.sh":true,"org.sh":true,"gov.sh":true,"edu.sh":true,"net.sh":true,"nom.sh":true,"com.sl":true,"net.sl":true,"org.sl":true,"edu.sl":true,"gov.sl":true,"gov.st":true,"saotome.st":true,"principe.st":true,"consulado.st":true,"embaixada.st":true,"org.st":true,"edu.st":true,"net.st":true,"com.st":true,"store.st":true,"mil.st":true,"co.st":true,"edu.sv":true,"gob.sv":true,"com.sv":true,"org.sv":true,"red.sv":true,"co.sz":true,"ac.sz":true,"org.sz":true,"com.tr":true,"gen.tr":true,"org.tr":true,"biz.tr":true,"info.tr":true,"av.tr":true,"dr.tr":true,"pol.tr":true,"bel.tr":true,"tsk.tr":true,"bbs.tr":true,"k12.tr":true,"edu.tr":true,"name.tr":true,"net.tr":true,"gov.tr":true,"web.tr":true,"tel.tr":true,"tv.tr":true,"co.tt":true,"com.tt":true,"org.tt":true,"net.tt":true,"biz.tt":true,"info.tt":true,"pro.tt":true,"int.tt":true,"coop.tt":true,"jobs.tt":true,"mobi.tt":true,"travel.tt":true,"museum.tt":true,"aero.tt":true,"cat.tt":true,"tel.tt":true,"name.tt":true,"mil.tt":true,"edu.tt":true,"gov.tt":true,"edu.tw":true,"gov.tw":true,"mil.tw":true,"com.tw":true,"net.tw":true,"org.tw":true,"idv.tw":true,"game.tw":true,"ebiz.tw":true,"club.tw":true,"com.mu":true,"gov.mu":true,"net.mu":true,"org.mu":true,"ac.mu":true,"co.mu":true,"or.mu":true,"ac.mz":true,"co.mz":true,"edu.mz":true,"org.mz":true,"gov.mz":true,"com.na":true,"co.na":true,"ac.nz":true,"co.nz":true,"cri.nz":true,"geek.nz":true,"gen.nz":true,"govt.nz":true,"health.nz":true,"iwi.nz":true,"maori.nz":true,"mil.nz":true,"net.nz":true,"org.nz":true,"parliament.nz":true,"school.nz":true,"abo.pa":true,"ac.pa":true,"com.pa":true,"edu.pa":true,"gob.pa":true,"ing.pa":true,"med.pa":true,"net.pa":true,"nom.pa":true,"org.pa":true,"sld.pa":true,"com.pt":true,"edu.pt":true,"gov.pt":true,"int.pt":true,"net.pt":true,"nome.pt":true,"org.pt":true,"publ.pt":true,"com.py":true,"edu.py":true,"gov.py":true,"mil.py":true,"net.py":true,"org.py":true,"com.qa":true,"edu.qa":true,"gov.qa":true,"mil.qa":true,"net.qa":true,"org.qa":true,"asso.re":true,"com.re":true,"nom.re":true,"ac.ru":true,"adygeya.ru":true,"altai.ru":true,"amur.ru":true,"arkhangelsk.ru":true,"astrakhan.ru":true,"bashkiria.ru":true,"belgorod.ru":true,"bir.ru":true,"bryansk.ru":true,"buryatia.ru":true,"cbg.ru":true,"chel.ru":true,"chelyabinsk.ru":true,"chita.ru":true,"chukotka.ru":true,"chuvashia.ru":true,"com.ru":true,"dagestan.ru":true,"e-burg.ru":true,"edu.ru":true,"gov.ru":true,"grozny.ru":true,"int.ru":true,"irkutsk.ru":true,"ivanovo.ru":true,"izhevsk.ru":true,"jar.ru":true,"joshkar-ola.ru":true,"kalmykia.ru":true,"kaluga.ru":true,"kamchatka.ru":true,"karelia.ru":true,"kazan.ru":true,"kchr.ru":true,"kemerovo.ru":true,"khabarovsk.ru":true,"khakassia.ru":true,"khv.ru":true,"kirov.ru":true,"koenig.ru":true,"komi.ru":true,"kostroma.ru":true,"kranoyarsk.ru":true,"kuban.ru":true,"kurgan.ru":true,"kursk.ru":true,"lipetsk.ru":true,"magadan.ru":true,"mari.ru":true,"mari-el.ru":true,"marine.ru":true,"mil.ru":true,"mordovia.ru":true,"mosreg.ru":true,"msk.ru":true,"murmansk.ru":true,"nalchik.ru":true,"net.ru":true,"nnov.ru":true,"nov.ru":true,"novosibirsk.ru":true,"nsk.ru":true,"omsk.ru":true,"orenburg.ru":true,"org.ru":true,"oryol.ru":true,"penza.ru":true,"perm.ru":true,"pp.ru":true,"pskov.ru":true,"ptz.ru":true,"rnd.ru":true,"ryazan.ru":true,"sakhalin.ru":true,"samara.ru":true,"saratov.ru":true,"simbirsk.ru":true,"smolensk.ru":true,"spb.ru":true,"stavropol.ru":true,"stv.ru":true,"surgut.ru":true,"tambov.ru":true,"tatarstan.ru":true,"tom.ru":true,"tomsk.ru":true,"tsaritsyn.ru":true,"tsk.ru":true,"tula.ru":true,"tuva.ru":true,"tver.ru":true,"tyumen.ru":true,"udm.ru":true,"udmurtia.ru":true,"ulan-ude.ru":true,"vladikavkaz.ru":true,"vladimir.ru":true,"vladivostok.ru":true,"volgograd.ru":true,"vologda.ru":true,"voronezh.ru":true,"vrn.ru":true,"vyatka.ru":true,"yakutia.ru":true,"yamal.ru":true,"yekaterinburg.ru":true,"yuzhno-sakhalinsk.ru":true,"ac.rw":true,"co.rw":true,"com.rw":true,"edu.rw":true,"gouv.rw":true,"gov.rw":true,"int.rw":true,"mil.rw":true,"net.rw":true,"com.sa":true,"edu.sa":true,"gov.sa":true,"med.sa":true,"net.sa":true,"org.sa":true,"pub.sa":true,"sch.sa":true,"com.sd":true,"edu.sd":true,"gov.sd":true,"info.sd":true,"med.sd":true,"net.sd":true,"org.sd":true,"tv.sd":true,"a.se":true,"ac.se":true,"b.se":true,"bd.se":true,"c.se":true,"d.se":true,"e.se":true,"f.se":true,"g.se":true,"h.se":true,"i.se":true,"k.se":true,"l.se":true,"m.se":true,"n.se":true,"o.se":true,"org.se":true,"p.se":true,"parti.se":true,"pp.se":true,"press.se":true,"r.se":true,"s.se":true,"t.se":true,"tm.se":true,"u.se":true,"w.se":true,"x.se":true,"y.se":true,"z.se":true,"com.sg":true,"edu.sg":true,"gov.sg":true,"idn.sg":true,"net.sg":true,"org.sg":true,"per.sg":true,"art.sn":true,"com.sn":true,"edu.sn":true,"gouv.sn":true,"org.sn":true,"perso.sn":true,"univ.sn":true,"com.sy":true,"edu.sy":true,"gov.sy":true,"mil.sy":true,"net.sy":true,"news.sy":true,"org.sy":true,"ac.th":true,"co.th":true,"go.th":true,"in.th":true,"mi.th":true,"net.th":true,"or.th":true,"ac.tj":true,"biz.tj":true,"co.tj":true,"com.tj":true,"edu.tj":true,"go.tj":true,"gov.tj":true,"info.tj":true,"int.tj":true,"mil.tj":true,"name.tj":true,"net.tj":true,"nic.tj":true,"org.tj":true,"test.tj":true,"web.tj":true,"agrinet.tn":true,"com.tn":true,"defense.tn":true,"edunet.tn":true,"ens.tn":true,"fin.tn":true,"gov.tn":true,"ind.tn":true,"info.tn":true,"intl.tn":true,"mincom.tn":true,"nat.tn":true,"net.tn":true,"org.tn":true,"perso.tn":true,"rnrt.tn":true,"rns.tn":true,"rnu.tn":true,"tourism.tn":true,"ac.tz":true,"co.tz":true,"go.tz":true,"ne.tz":true,"or.tz":true,"biz.ua":true,"cherkassy.ua":true,"chernigov.ua":true,"chernovtsy.ua":true,"ck.ua":true,"cn.ua":true,"co.ua":true,"com.ua":true,"crimea.ua":true,"cv.ua":true,"dn.ua":true,"dnepropetrovsk.ua":true,"donetsk.ua":true,"dp.ua":true,"edu.ua":true,"gov.ua":true,"if.ua":true,"in.ua":true,"ivano-frankivsk.ua":true,"kh.ua":true,"kharkov.ua":true,"kherson.ua":true,"khmelnitskiy.ua":true,"kiev.ua":true,"kirovograd.ua":true,"km.ua":true,"kr.ua":true,"ks.ua":true,"kv.ua":true,"lg.ua":true,"lugansk.ua":true,"lutsk.ua":true,"lviv.ua":true,"me.ua":true,"mk.ua":true,"net.ua":true,"nikolaev.ua":true,"od.ua":true,"odessa.ua":true,"org.ua":true,"pl.ua":true,"poltava.ua":true,"pp.ua":true,"rovno.ua":true,"rv.ua":true,"sebastopol.ua":true,"sumy.ua":true,"te.ua":true,"ternopil.ua":true,"uzhgorod.ua":true,"vinnica.ua":true,"vn.ua":true,"zaporizhzhe.ua":true,"zhitomir.ua":true,"zp.ua":true,"zt.ua":true,"ac.ug":true,"co.ug":true,"go.ug":true,"ne.ug":true,"or.ug":true,"org.ug":true,"sc.ug":true,"ac.uk":true,"bl.uk":true,"british-library.uk":true,"co.uk":true,"cym.uk":true,"gov.uk":true,"govt.uk":true,"icnet.uk":true,"jet.uk":true,"lea.uk":true,"ltd.uk":true,"me.uk":true,"mil.uk":true,"mod.uk":true,"national-library-scotland.uk":true,"nel.uk":true,"net.uk":true,"nhs.uk":true,"nic.uk":true,"nls.uk":true,"org.uk":true,"orgn.uk":true,"parliament.uk":true,"plc.uk":true,"police.uk":true,"sch.uk":true,"scot.uk":true,"soc.uk":true,"4fd.us":true,"dni.us":true,"fed.us":true,"isa.us":true,"kids.us":true,"nsn.us":true,"com.uy":true,"edu.uy":true,"gub.uy":true,"mil.uy":true,"net.uy":true,"org.uy":true,"co.ve":true,"com.ve":true,"edu.ve":true,"gob.ve":true,"info.ve":true,"mil.ve":true,"net.ve":true,"org.ve":true,"web.ve":true,"co.vi":true,"com.vi":true,"k12.vi":true,"net.vi":true,"org.vi":true,"ac.vn":true,"biz.vn":true,"com.vn":true,"edu.vn":true,"gov.vn":true,"health.vn":true,"info.vn":true,"int.vn":true,"name.vn":true,"net.vn":true,"org.vn":true,"pro.vn":true,"co.ye":true,"com.ye":true,"gov.ye":true,"ltd.ye":true,"me.ye":true,"net.ye":true,"org.ye":true,"plc.ye":true,"ac.yu":true,"co.yu":true,"edu.yu":true,"gov.yu":true,"org.yu":true,"ac.za":true,"agric.za":true,"alt.za":true,"bourse.za":true,"city.za":true,"co.za":true,"cybernet.za":true,"db.za":true,"ecape.school.za":true,"edu.za":true,"fs.school.za":true,"gov.za":true,"gp.school.za":true,"grondar.za":true,"iaccess.za":true,"imt.za":true,"inca.za":true,"kzn.school.za":true,"landesign.za":true,"law.za":true,"lp.school.za":true,"mil.za":true,"mpm.school.za":true,"ncape.school.za":true,"net.za":true,"ngo.za":true,"nis.za":true,"nom.za":true,"nw.school.za":true,"olivetti.za":true,"org.za":true,"pix.za":true,"school.za":true,"tm.za":true,"wcape.school.za":true,"web.za":true,"ac.zm":true,"co.zm":true,"com.zm":true,"edu.zm":true,"gov.zm":true,"net.zm":true,"org.zm":true,"sch.zm":true}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,604,664,546,774,888,179], function() { return __webpack_exec__(247); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);